fx.ns("models", class User extends fx.Model {

	constructor(data)
	{
		super(data);
    }

	get isRegistered()
	{
		return !!this.email;
	}

	get requestDefaultParams()
	{
		return {connectionid : fx.get("connectionid")};
	}

	get password()
	{
		return this._password;
	}

	login(email, password, creationid, accountid)
	{
		this.event("login-sent");

		this._password = password;

		this.post( 
						"/api/login",
						{ 
							email : email,
							password : password,
							creationid : creationid,
							accountid : accountid
						}, 
						this._logged
					);
	}

	_logged(data)
	{
		if (data.failed)
			this.event("login-failed", data);
		else
		{
			this.init(data);
			this.event("login-succeed");
		}
			
	}


	register(email, password, creationid, accountid)
	{
		this.event("register-sent");

		this._password = password;
        
		this.post( 
			"/api/register",
			{ 
				email : email,
				password : password,
				creationid : creationid,
				accountid : accountid
			}, 
			this._registered
		);
	}

	_registered(data)
	{
		if (data.failed)
			this.event("register-failed", data);
		else
		{
			this.init(data);
			this.event("register-succeed");
		}
	}

    get device()
    {
        return fx.get("app-device") || "";
    }

    get project()
    {
        return fx.get("app-project") || "";
    }

    // User Notifications (used for help bubbles : choose your cover, crop picture, etc...)
    wasNotificated()
    {
        let notifications = this.notifications ? JSON.parse(this.notifications) : {};
        
        let notificated = true;
        for(let i = 0; i < arguments.length; i++)
            notificated = notificated && !!notifications[this.device + "-" + this.project + "-" + arguments[i]];

        return notificated;
    }

    notificated(name)
    {
        let notifications = this.notifications ? JSON.parse(this.notifications) : {};
        
        notifications[this.device + "-" + this.project + "-" + name] = true;

        this.notifications = JSON.stringify(notifications);
    }
    
});